<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="studentId!=null && studentId!='' && studentId!='new'">Оюутны мэдээлэл засах</span>
                      <span v-else>Оюутан нэмэх</span>
                      
                    </h1>
                  </div>
                  <form class="user">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Нэр</label>
                        <input v-model.trim="student.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Нэр">
                      </div>
                      <div class="col-md-6 col-sm-12form-group">
                        <label>Овог</label>
                        <input v-model.trim="student.lastname" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Овог">
                      </div>
                    </div>
                    <div class="form-group" >
                      <label>Оюутны код</label>
                      
                      <input v-if="student.id==null || student.id==undefined" v-model.trim="student.code" type="text" class="form-control"  placeholder="Оюутны код оруулна уу">
                      <input v-else v-model.trim="student.code" disabled="disabled" type="text" class="form-control"  placeholder="Оюутны код оруулна уу">
                      
                    </div>
                    <div class="form-group" >
                      <label>Регистрийн дугаар</label>
                      <input v-if="student.id==null || student.id==undefined" v-model.trim="student.register" type="text" class="form-control"  placeholder="Оюутны регистрийн дугаар оруулна уу">
                      <input v-else disabled="disabled" v-model.trim="student.register" type="text" class="form-control"  placeholder="Оюутны регистрийн дугаар оруулна уу">
                    
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label>Утасны дугаар 1</label>
                        <input v-model.trim="student.phone" type="text" class="form-control"  placeholder="Утасны дугаар 1 оруулна уу">
                      </div>
                      <div class="col form-group">
                        <label>Утасны дугаар 2</label>
                        <input v-model.trim="student.phone2" type="text" class="form-control"  placeholder="Утасны дугаар 2 оруулна уу">
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Имэйл</label>
                      <input v-model.trim="student.email" type="text" class="form-control"  placeholder="Имэйл оруулна уу">
                    </div>
                    <div class="form-group">
                      <label>Гэрийн хаяг</label>
                      <textarea v-model.trim="student.address" type="text" class="form-control"  placeholder="Гэрийн хаяг оруулна уу"></textarea>
                    </div>

                    <div class="form-group">
                      <div class="radio">
                        <label><input type="radio" name="gendergroup" value="male" v-model="student.gender" v-bind:checked="student.gender && student.gender=='male'?'checked':''">Эр</label>
                      </div>
                      <div class="radio">
                        <label><input type="radio" name="gendergroup" value="female" v-model="student.gender" v-bind:checked="student.gender && student.gender=='female'?'checked':''">Эм</label>
                      </div>
                    </div>
                    <hr/>
                    <div class="form-group">
                      <div class="radio">
                        <label><input type="radio" name="typegroup" value="shift" v-model="student.type" v-bind:checked="student.type && student.type=='shift'?'checked':''">Шилжиж ирсэн</label>
                      </div>
                      <div class="radio">
                        <label><input type="radio" name="typegroup" value="new" v-model="student.type" v-bind:checked="student.type && student.type=='new'?'checked':''">Шинэ</label>
                      </div>
                    </div>
                    <hr/>

                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Элсэн орсон: </label>
                      <select class="form-control" v-model="semester">
                        <option v-for="(s, index) in semesters" v-bind:key="s.id" v-bind:value="s">{{index+1}}.  {{s.data().title}}</option>
                      </select>
                    </div>
                    <hr/>
                    <div v-if="student.birth">
                      <div class="text-center font-weight-bold" >Төрсөн огноо</div>
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Төрсөн он</label>
                            <select class="form-control" v-model='student.birth.year'>
                              <option v-for="year in years" v-bind:value="year">{{year}} он</option>
                            </select>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Төрсөн сар</label>
                            <select class="form-control" v-model='student.birth.month'>
                              <option v-for="month in months" v-bind:value="month">{{month}} сар</option>
                            </select>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Төрсөн өдөр</label>
                            <select class="form-control" v-model='student.birth.day'>
                              <option v-for="day in days" v-bind:value="day">{{day}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr/>
                    <div v-if="student.iaddress">
                      <div class="text-center font-weight-bold" >Оршин суугаа хаяг</div>
                      <div class="row"> 
                        
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Хот: </label>
                            <select class="form-control" v-model="city" >
                              <option v-for="(school, index) in cities" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col" v-if="city">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Дүүрэг/Сум: </label>
                            <select class="form-control" v-model="district" >
                              <option v-for="(dep, index) in city.districts" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="district"> 
                        
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Хороо/баг/: </label>
                            <input v-model.trim="student.iaddress.horoo" type="text" class="form-control"  placeholder="Хороо/баг/">
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Байшин хашаа:  </label>
                            <input v-model.trim="student.iaddress.building" type="text" class="form-control"  placeholder="Байшин хашаа">
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Тоот:  </label>
                            <input v-model.trim="student.iaddress.entrynumber" type="text" class="form-control"  placeholder="Тоот">
                    
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div >
                      <div class="text-center font-weight-bold" >Хаанаас</div>
                      <div class="row"> 
                        
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Хот: </label>
                            <select class="form-control" v-model="city1" >
                              <option v-for="(school, index) in cities" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col" v-if="city1">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Дүүрэг/Сум: </label>
                            <select class="form-control" v-model="district1" >
                              <option v-for="(dep, index) in city.districts" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="form-group" v-if="district1">
                          <label for="exampleFormControlSelect1">Сургууль: </label>
                          <input v-model.trim="student.preschool.schoolname" type="text" class="form-control"  placeholder="Сургууль">
                      </div>
                    </div>

                    <hr/>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Сургууль</label>
                          <select class="form-control" v-model="school" @change="schoolChanged">
                            <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="school!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Тэнхим</label>
                          <select class="form-control" v-model="department" >
                            <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="department!=null">
                      <label for="exampleFormControlSelect1">Хөтөлбөр</label>
                      <select class="form-control" v-model="program" >
                        <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.data().name}}</option>
                      </select>
                    </div>
                    <div class="form-group" v-if="department && program">
                      <label for="exampleFormControlSelect1">Мэргэжил төлөвлөгөө</label>
                      <select class="form-control" v-model="programYear" >
                        <option v-for="(pro, index) in program.programYears" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.data().name}} - <span v-if="pro.data().startDay">{{pro.data().startDay.year}}</span></option>
                      </select>
                    </div>

                    <div class="row" v-if="program && courses && student">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Анги</label>
                          <select class="form-control" v-model="student.course">
                              <option v-for="course in courses" v-bind:value="course">{{course}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Бүлэг</label>
                          <select class="form-control" v-model="student.group">
                              <option v-for="group in groups" v-bind:value="group">{{group}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                   
                    <!-- <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck">Remember Me</label>
                      </div>
                    </div> -->
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "StudentAdd",
    data() {
        return {
            student: {
                name: '',
                lastname:'',
                phone:'',
                phone2:'',
                code:'',
                email:'',
                address:'',
                register:'',
                birth:{
                  year:null,
                  month:null, 
                  day:null
                },
                iaddress:{
                  city:null,
                  district:null,
                  horoo:null,
                  building:null,
                  entrynumber:null
                },
                preschool:{
                  city:null,
                  district:null,
                  schoolname:null
                },
                gender:null,
                type:null,
                entry:{
                  semester:null
                },
                course:null,
                group:null
 
            },
            performingRequest:false,
            schools:[],
            school:null,
            department:null,
            program:null,
            programYear:null,
            years:[],
            months:[],
            days:[],
            cities:[],
            city:null,
            district:null,
            city1:null,
            district1:null,
            semesters:[],
            semester:null,
            courses:[1,2,3,4,5,6],
            groups: ['A', 'B', 'C', 'D']
        };
    },
    methods: {
        save() {
            this.performingRequest = true
            if(this.student!=null && this.student.name!='' && this.student.code!='' && this.student.register && this.school && this.department && this.program){
              if(this.student.id!=null && this.student.id!='' && this.student.id!='new'){
                this.student.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                this.student.modifiedAt=new Date()
                if(this.school!=null)
                  this.student.school=this.school.ref
                if(this.department!=null)
                  this.student.department=this.department.ref
                if(this.program!=null)
                  this.student.program=this.program.ref;
                if(this.programYear!=null)
                  this.student.programYear=this.programYear.ref;

                if(this.city){
                  this.student.iaddress.cityName=this.city.data().name;
                  this.student.iaddress.city=this.city.ref;
                                   
                }
                if(this.district){
                  this.student.iaddress.districtName=this.district.data().name;
                  this.student.iaddress.district=this.district.ref;
                }

                if(this.city1){
                  this.student.preschool.cityName=this.city1.data().name;
                  this.student.preschool.city=this.city1.ref;
                                   
                }
                if(this.district1){
                  this.student.preschool.districtName=this.district1.data().name;
                  this.student.preschool.district=this.district1.ref;
                }
                if(this.semester){
                  this.student.entry.semester=this.semester.ref;
                  this.student.entry.data=this.semester.data().date;
                  
                }
                fb.db.collection("students").doc(this.student.id).update(this.student)

                this.$router.back();
              }
              else{
                
                fb.db.collection("students").doc(this.student.code.toLowerCase()).get().then(doc=>{
                  if(doc.exists){
                    alert(this.student.code+" кодтой оюутан бүртгэгдсэн байна.")
                    return ;
                  }
                  else{
                    this.student.code=this.student.code.toLowerCase();
                    this.student.register=this.student.register.toLowerCase();
                    fb.db.collection("students").where("register", "==", this.student.register).get().then((sts)=>{
                      if(sts.empty==true){
                        this.student.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        this.student.createdAt=new Date()
                        if(this.school!=null){
                          this.student.school=this.school.ref
                          this.school.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)})
                        }
                        if(this.department!=null){
                          this.student.department=this.department.ref
                          this.department.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)})
                        }
                        if(this.program!=null){
                          this.student.program=this.program.ref
                          this.program.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)});
                        }
                        if(this.programYear!=null){
                          this.student.programYear=this.programYear.ref;
                          this.programYear.ref.update({numberOfStudents: fb.firestore.FieldValue.increment(1)});
                        }
                        if(this.city){
                          this.student.iaddress.cityName=this.city.data().name;
                          this.student.iaddress.city=this.city.ref;
                                          
                        }
                        if(this.district){
                          this.student.iaddress.districtName=this.district.data().name;
                          this.student.iaddress.district=this.district.ref;
                        }

                        if(this.city1){
                          this.student.preschool.cityName=this.city1.data().name;
                          this.student.preschool.city=this.city1.ref;
                                          
                        }
                        if(this.district1){
                          this.student.preschool.districtName=this.district1.data().name;
                          this.student.preschool.district=this.district1.ref;
                        }
                        if(this.semester){
                          this.student.entry.semester=this.semester.ref;
                          this.student.entry.data=this.semester.data().date;
                          
                        }
                        doc.ref.set(this.student);
                        alert("Оюутан амжилттай бүртгэгдлээ.");
                        this.$router.back();
                      }
                      else{
                        alert(this.student.register+" регистртэй оюутан бүртгэгдсэн байна");
                      }
                    });
                    
                  }
                })
              }
                
            }
            else{
              alert("Оюутны нэр , код, регистр болон тэнхим хөтөлбөрийн мэдээлэл заавал оруулна уу.");
            }
        },
        setStudent(){
          this.student= {
              name: '',
              lastname:'',
              phone:'',
              phone2:'',
              code:'',
              email:'',
              address:''
          }
        },
       
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },
        _getSemester(){
          fb.db.collection("semester").orderBy("index")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this.semesters.push(schoolData);
                if(this.student.entry!=null && this.student.entry.semester && this.student.entry.semester.path==schoolData.ref.path){
                  this.semester=schoolData;
                }
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getSchools(){
          fb.db.collection("schools")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this._getDepartments(schoolData.id, schoolData)
                this.schools.push(schoolData)
                if(this.student.school!=null && this.student.school.path==schoolData.ref.path){
                  this.school=schoolData;
                }
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getDepartments(schoolId, schoolData){
          schoolData.ref.collection("departments")
          .get()
          .then(querySnapshot=> {
              let deps=[];
              querySnapshot.forEach(depdata=> {
                this._getPros(depdata);
                
                if(this.student.department && this.student.department.path==depdata.ref.path){
                  this.department=depdata;
                }
                deps.push(depdata);
              });
              schoolData.departments=deps;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getPros(depdata){
          depdata.ref.collection("programs")
          .get()
          .then(querySnapshot=> {
            let pros=[];
              querySnapshot.forEach(prodata=> {
                this._getProgramYears(prodata);
                pros.push(prodata);
                if(this.student.program!=null && this.student.program.path==prodata.ref.path){
                  this.program=prodata;
                }
              });
              depdata.programs=pros;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getProgramYears(depdata){
          depdata.ref.collection("programyears")
          .get()
          .then(querySnapshot=> {
            let pros=[];
              querySnapshot.forEach(prodata=> {
                pros.push(prodata);
                if(this.student.programYear!=null && this.student.programYear.path==prodata.ref.path){
                  this.programYear=prodata;
                }
              });
              depdata.programYears=pros;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },

        _getcities(){
          fb.db.collection("cities").orderBy("index")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this._getDistricts(schoolData.id, schoolData)
                this.cities.push(schoolData)
                if(this.student.iaddress && this.student.iaddress.city && this.student.iaddress.city.path==schoolData.ref.path){
                  this.city=schoolData;
                }
                if(this.student.preschool && this.student.preschool.city && this.student.preschool.city.path==schoolData.ref.path){
                  this.city1=schoolData;
                }
              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getDistricts(schoolId, schoolData){
          schoolData.ref.collection("districts").orderBy("index")
          .get()
          .then(querySnapshot=> {
              let deps=[];
              querySnapshot.forEach(depdata=> {
                this._getPros(depdata);
                deps.push(depdata);
                if(this.student.iaddress && this.student.iaddress.district && this.student.iaddress.district.path==depdata.ref.path){
                  this.district=depdata;
                }
                if(this.student.preschool && this.student.preschool.district && this.student.preschool.district.path==depdata.ref.path){
                  this.district1=depdata;
                }
              });
              schoolData.districts=deps;
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        schoolChanged(){
          this.department=null
          this.program=null
        },
        _getStudent(){
          if(this.studentId!=null && this.studentId!='' && this.studentId!='new'){
            fb.db.collection("students").doc(this.studentId).get().then(studentData=>{
              let object=studentData.data()
              object.id=studentData.id
              this.student=object;
              if(!this.student.birth){
                this.student.birth={
                  year:null,
                  month:null, 
                  day:null
                };
              }
              if(!this.student.iaddress){
                this.student.iaddress={
                  city:null,
                  district:null,
                  horoo:null,
                  building:null,
                  entrynumber:null
                };
              }
              if(!this.student.preschool){
                this.student.preschool={
                  city:null,
                  district:null,
                  schoolname:null

                };
              }
              if(!this.student.gender)
                this.student.gender=null;
              if(!this.student.type)
                this.student.type=null;
              if(!this.student.entry){
                this.student.entry={
                  semester:null

                };
              }
              if(!this.student.course)
                this.student.course=null;
              if(!this.student.group)
                this.student.group=null;

              this._getcities();
            });
          }
          else
            this._getcities();
          this._getSchools();
          this._getSemester();
        }
        // depChanged(){
        //   console.log(this.department)
        //   this.programs=[]
        //   if(this.department!=null && this.department.id!=null)
        //     this._getPros("schools/"+this.school.id+"/departments/"+this.department.id+"/programs");
        // }
        
        
        
    }, 
    props: {
        studentId: { 
            required: false,
        },
    },
    created() {
      for(var i=1970;i<=2020;i++){
        this.years.push(i);
      }
      for(var i=1;i<=12;i++){
        this.months.push(i);
      }
      for(var i=1;i<=31;i++){
        this.days.push(i);
      }
        this._getStudent();     
    },
  
};
</script>

